module.exports = __webpack_public_path__ + "static/img/white-logo-strip.80f22c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-logo-strip.svg
// module id = 1999
// module chunks = 1